import * as React from 'react';

type PaginationState = {
  page: number;
  currentParagraph: number;
};

type ReducerAction = {
  type: 'next_page' | 'next_paragraph' | 'previous_page' | 'previous_paragraph';
};

const stateReducer = (
  { currentParagraph, page }: PaginationState,
  { type }: ReducerAction
) => {
  switch (type) {
    case 'next_page':
      return { currentParagraph: currentParagraph + 1, page: page + 1 };
    case 'next_paragraph':
      return { currentParagraph: currentParagraph + 1, page };
    case 'previous_page':
      return { currentParagraph: currentParagraph - 1, page: page - 1 };
    case 'previous_paragraph':
      return { currentParagraph: currentParagraph - 1, page };
    default:
      throw new Error('You should not be here');
  }
};

export const useDocumentPagination = () => {
  const [{ currentParagraph, page }, dispatch] = React.useReducer(
    stateReducer,
    { currentParagraph: 1, page: 0 }
  );

  return { currentParagraph, page, dispatch };
};
